<template>
    <article>
        <rooster-header title="Reports"></rooster-header>

        <div class="row">
            <div class="col-lg-5 col-xl-4">
                <div class="form-group">
                    <label for="punches-from-ipt">Punches from</label>
                    <input id="punches-from-ipt" type="date"
                           v-model="punchesFrom"
                           min="2000-01-01"
                           :max="today"
                           @change="maybeShowReport"
                           class="form-control" />
                </div>

                <div class="form-group">
                    <label for="punches-to-ipt">Punches to</label>
                    <input id="punches-to-ipt" type="date"
                           v-model="punchesTo"
                           min="2000-01-01"
                           :max="today"
                           @change="maybeShowReport"
                           class="form-control" />
                </div>

                <div class="form-group">
                    <label for="punches-for-prj-ipt">For project</label>

                    <b-form-select id="punches-for-prj-ipt"
                                   v-model="selectedProject"
                                   :options="projectSelectorOptions"
                                   @change="onProjectChange">
                    </b-form-select>
                </div>

                <div class="form-group">
                    <label for="punches-for-clt-ipt">For client</label>

                    <b-form-select id="punches-for-clt-ipt"
                                   v-model="selectedClient"
                                   @change="onClientChange"
                                   :options="clientSelectorOptions">
                    </b-form-select>
                </div>
            </div>

            <div class="col-lg-7 col-xl-8">
                <p class="alert alert-info" v-if="!filterReady()">Select the project or client, and date range.</p>

                <div v-if="loading" class="text-center">
                    <b-spinner  label="making the report.."></b-spinner>
                </div>

                <template v-if="report">
                    <p v-if="report.length>0" class="alert alert-info">
                        <span class="float-right">
                            <button class="btn btn-outline-secondary btn-sm" @click.prevent="exportCsv"><i class="fas fa-download"></i> csv</button>
                        </span>
                        Total: <strong>{{totalHours}} h</strong>
                        <small>
                            <span v-if="selectedProject && selectedProject.rate" class="text-muted">x {{selectedProject.rate}}/h = </span>
                            <template v-if="totalBillableAvailable">{{ totalBillable }} $</template>
                        </small>
                    </p>



                    <b-table :items="report.map(function(row) { delete row['billable']; return row; } )">
                        <!-- secs to hours -->
                        <template slot="duration" slot-scope="data">
                            {{ data.value }}
                        </template>
                    </b-table>
                    <p v-if="report.length==0" class="alert alert-info">Nothing tracked for this project yet.</p>
                </template>
            </div>
        </div>
    </article>
</template>

<script>
    import {BFormSelect} from 'bootstrap-vue';
    Vue.component('b-form-select', BFormSelect);

    import {BSpinner} from 'bootstrap-vue';
    Vue.component('b-spinner', BSpinner);


    export default {
        name: "Reports",
        props: [
            "today",
            "homeUrl"
        ],

        data() {
            return {
                punchesFrom: "",
                punchesTo: "",
                projects: [],
                selectedProject: null,
                clients: [],
                selectedClient: null,
                loading: false,
                report: null,
                totalBillable: null,
                axCtrl: null,
            }
        },

        watch: {
            report (val) {
                if (!val) {
                    this.totalBillable = null;
                    return ;
                }

                let accum=0;
                for (let i=0; i<val.length; i++) {
                    if (typeof val[i].billable == "undefined") {
                        return ;
                    }

                    accum+= val[i].billable;
                }
                this.totalBillable = Math.round(accum*100)/100;
            }
        },

        computed: {
            projectSelectorOptions() {
                if (this.projects.length === 0) {
                    return [];
                }

                const interm = _.map(this.projects, function(el) {
                    const clientString = el.client ? " [" + el.client.name + "]" : "";
                    return {
                        value: el,
                        text: el.name + clientString
                    }
                });

                return [{
                    value: null,
                    text: "Any",
                }].concat(interm);
            },

            clientSelectorOptions() {
                if (this.projects.length === 0) {
                    return [];
                }

                const interm = _.map(this.clients, function(el) {
                    return {
                        value: el,
                        text: el.name
                    }
                });

                return [{
                    value: null,
                    text: "--",
                }].concat(interm);
            },

            totalHours() {
                if (!this.report) {
                    return "";
                }

                let hours = _.reduce(this.report, function(res, val, key){
                    if (typeof val.duration == "undefined" || val.duration=="") {
                        return res;
                    }

                    return res + parseFloat(val.duration);
                }, 0);

                return Math.round(hours*100)/100;
            },

            totalBillableAvailable() {
                return this.totalBillable !== null;
            }
        },

        mounted() {
            this.punchesFrom = this.today;

            const that = this;
            window.axios.get('api/user')
                .then(function(resp){
                    //that.user = resp.data.user;
                    that.projects = resp.data.projects;
                    that.clients = resp.data.clients;

                    if (that.projects.length) {
                        that.selectedProject = that.projects[0];
                        that.maybeShowReport();
                    }
                }).catch(function(err, resp){
                    alert("Oops, there was an error fetching data form server.");
                    console.log(err.message);
                });
        },

        methods: {
            filterReady() {
                return (this.punchesFrom != "") && (this.selectedProject!=null || this.selectedClient!=null);
            },

            maybeShowReport() {
                if (!this.filterReady()) {
                    return ;
                }

                if (this.axCtrl !== null) {
                    //console.log("aborting..");
                    this.axCtrl.abort();
                }

                var that = this;
                this.report = null;
                this.loading = true;

                this.axCtrl = new AbortController();
                axios.get('api/report/classic', {
                    params: {
                        project: this.selectedProject ? this.selectedProject.id : null,
                        client: this.selectedClient ? this.selectedClient.id : null,
                        from: this.punchesFrom,
                        until: this.punchesTo
                    },
                    signal: this.axCtrl.signal,
                    timeout: 20000
                }).then(function(resp){
                    // make sure the first report row has all fields
                    if (resp.data.length && typeof resp.data[0].duration == "undefined") {
                        resp.data[0].duration = '';
                    }

                    that.report = resp.data;
                    that.axCtrl = null;
                    that.loading = false;
                }).catch(function(err, resp){
                    if (err.code != "ERR_CANCELED") {
                        if (err.message) {
                            alert(err.message);
                        } else {
                            alert("Oops, there was an error fetching data form server.");
                        }
                        that.loading = false;
                    }
                });
            },

            secsToHours(s) {
                return Math.round(s / 36) / 100
            },

            round(val) {
                return Math.round(val * 100) / 100;
            },

            exportCsv() {
                let filter = "";
                if (this.selectedProject) {
                    filter += "project=" + this.selectedProject.id;
                } else {
                    filter += "client=" + this.selectedClient.id;
                }
                window.location.href = this.homeUrl + "/report/export?" + filter
                    + "&from=" + this.punchesFrom + "&until=" + this.punchesTo;
            },

            onProjectChange(e) {
                this.report = false;
                if (e) {
                    this.selectedClient = null;
                }
                this.maybeShowReport();
            },

            onClientChange(e) {
                this.report = false;
                if (e) {
                    this.selectedProject = null;
                }
                this.maybeShowReport();
            }
        }
    }
</script>
